import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsAndConditions from './components/TermsAndConditions';
import Layout from './components/Layout';

function App() {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/privacy-policy/:appId" element={<PrivacyPolicy />} />
          <Route path="/terms-and-conditions/:appId" element={<TermsAndConditions />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;
